/* import __COLOCATED_TEMPLATE__ from './select-question.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestionTypesSelectQuestion extends Component {
  @service intl;

  get currentValue() {
    return this.args.validationModel?.value;
  }

  get hasValue() {
    return !!this.currentValue;
  }

  get processedOptions() {
    let markSelected = opt => ({
      ...opt,
      selected: this._isOptionSelected(opt.value),
    });

    return this.args.question.options.map(opt =>
      opt.options
        ? {
            ...opt,
            options: opt.options.map(markSelected),
          }
        : markSelected(opt)
    );
  }

  get subText() {
    if (this.args.question.subtext) {
      return this.intl.t(this.args.question.subtext);
    }
    return null;
  }

  _isOptionSelected(optionValue) {
    return this.currentValue === optionValue;
  }

  @action
  onSelect(question, value) {
    this.args.onChange?.(question, value);
  }
}
